import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';
import globalUserPage from '../../../../../../../stores/global-user-page';
import { CardBrandType } from '../../../../../../../api/types/students/credit-card-tokens/credit-card-token-entity';
import { toast } from 'react-toastify';

export const addCreditCardTokenOperation = async (
  userId: number,
  data: {
    token: string;
    cardLast4: string;
    expiryMonth: number;
    expiryYear: number;
    cardBrand: CardBrandType;
  },
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
): Promise<boolean> => {
  const token = (data.token || '').trim();
  const cardLast4 = (data.cardLast4 || '').trim();

  if (!/^\d{10}$/.test(token)) {
    toast.warn('יש להזין טוקן בן 10 ספרות');
    return false;
  }
  if (!/^\d{4}$/.test(cardLast4)) {
    toast.warn('יש להזין 4 ספרות אחרונות של הכרטיס');
    return false;
  }
  if (data.expiryMonth < 1 || data.expiryMonth > 12) {
    toast.warn('חודש תפוגה לא תקין');
    return false;
  }
  if (data.expiryYear < 2000 || data.expiryYear > 2100) {
    toast.warn('שנת תפוגה לא תקינה');
    return false;
  }

  try {
    setLoading(true);

    const res = await appApi.createCreditCardToken({
      card_brand: data.cardBrand,
      token,
      card_last_4: cardLast4,
      expiry_month: data.expiryMonth,
      expiry_year: data.expiryYear,
      userId,
      gateway_provider: 'pelecard',
    });

    if (res.data?.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('כרטיס האשראי נוסף בהצלחה');

    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    setLoading(false);
    onSuccess();
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
